<template>
  <href-url :value="value"
            :label="label"
            :title="title"
            :width="width"
            :mailto="true"
  />
</template>

<script>
import hrefUrl from '@/components/backoffice/type/url/href'

export default {
  components: {
    hrefUrl
  },
  props: {
    value: {
      type: String
    },
    label: String,
    title: String,
    width: String
  }
}
</script>
